export default "__VITE_ASSET__CzFcNbpl__"